import { DateTime } from "luxon";
import useTypedSelector from "./useTypedSelector";

const MST_ZONE = "America/Edmonton";

const parseToMST = (dateStr: string): DateTime | null => {
    if (!dateStr) return null;
    // Try ISO first, then SQL format
    let dt = DateTime.fromISO(dateStr.replace(' ', 'T'));
    if (!dt.isValid) dt = DateTime.fromSQL(dateStr);
    if (!dt.isValid) return null;
    return dt.setZone(MST_ZONE);
};

const useBannerVisible = (): boolean => {
    const showBanner = useTypedSelector(state => state.toggles.showBanner);
    const startDate = useTypedSelector(state => state.toggles.startDate);
    const endDate = useTypedSelector(state => state.toggles.endDate);

    if (!showBanner || !startDate || !endDate) return false;

    const now = DateTime.local().setZone(MST_ZONE);
    const start = parseToMST(startDate);
    const end = parseToMST(endDate);

    if (!start || !end) return false;

    return now >= start.startOf('day') && now <= end.endOf('day');
};

export default useBannerVisible;
